var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2486 0.24332L9.28058 1.41744C9.11661 1.47923 8.98544 1.63372 8.98544 1.78821V9.75985C8.98544 9.91434 8.85426 10.0688 8.6903 10.1306L4.78786 11.3047C4.62389 11.3665 4.49272 11.2738 4.49272 11.1193V3.11682C4.49272 2.96233 4.36154 2.86963 4.19758 2.93143L0.295142 4.10555C0.131174 4.16734 0 4.32183 0 4.47632V25.7031C0 25.8576 0.131174 25.9503 0.295142 25.8885L4.26316 24.7144C4.42713 24.6526 4.55831 24.4981 4.55831 24.3436V16.3102C4.55831 16.1557 4.68948 16.0012 4.85345 15.9394L8.75588 14.7653C8.91985 14.7035 9.05102 14.7962 9.05102 14.9507V22.9841C9.05102 23.1386 9.1822 23.2313 9.34617 23.1695L13.3142 21.9954C13.4782 21.9336 13.6093 21.7791 13.6093 21.6246V0.428707C13.5437 0.274218 13.4126 0.212422 13.2486 0.24332Z",
    fill: "#35383D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/H.3eb307d57a7ca672cd9b75fce014942a.svg";
export { ForwardRef as ReactComponent };